import { css } from '@emotion/react';

import useTheme from '../../hooks/useTheme';

export default () => {
  const { breakpoints, colors, spacing } = useTheme();
  return {
    aside: filterShowHide => css`
      position: absolute;
      left: 0;
      max-height: 100vh;
      z-index: 1200;
      background: ${colors.white};
      opacity: ${filterShowHide ? '1' : '0'};
      display: flex;
      flex-direction: column;
      transform: translateX(${filterShowHide ? '0' : '-100%'});
      transition:
        transform 0.5s ease-in-out,
        opacity 0.5s ease-in-out;

      @media (max-width: 767px) {
        width: 100vw;
        min-width: 0;
        right: auto;
        max-height: 100vh;
      }
    `,
    overlay: (filterShowHide, page) => css`
      position: fixed;
      top: ${page === 'map' ? 1 : 0};
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.2);
      z-index: 1199;
      opacity: ${filterShowHide ? '1' : '0'};
      transition: opacity 0.5s ease-in-out;
    `,
    asidebar: css`
      display: flex;
      flex-direction: column;
      width: 375px;
      @media (max-width: 767px) {
        width: 100%;
      }
      padding: 0px;
      background: ${colors.white};
      height: 100%;
      position: relative;
      overflow-y: auto;
    `,
    filters: page => css`
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      flex: 1 1 auto;
      min-height: 0;
      width: 100%;
      padding: 2rem 2rem 6rem 2rem;
      @media (max-width: 767px) {
        padding: ${page === 'map' ? '6rem' : '2rem'} 2rem 6rem 2rem;
      }
      box-sizing: border-box;
    `,
    filter: css`
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 0.5rem;
      border-bottom: 1px solid #e4e7ec;
      margin-bottom: 1.5rem;
      padding-bottom: ${spacing.s};
      @media (max-width: 767px) {
       width: 100%;
      }
    `,
    filterHead: css`
      display: flex;
      width: 19.4375rem;
      height: 1.5rem;
      align-items: center;
      gap: 1.125rem;
      justify-content: space-between;
    `,
    filterTitle: css`
      color: #011e41;
      /* FDS Mobile/Headline/H5 */
      font-family: 'FS Dillon';
      font-size: 1.35rem;
      font-style: normal;
      font-weight: 700;
      line-height: 1.5rem; /* 111.111% */
      letter-spacing: 0.0014rem;
      display: inline-flex;
      align-items: center;
      gap: 0.5rem;
      svg {
        display: block;
      }
    `,
    filterBody: css`
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 0.5rem;
      align-self: stretch;
    `,
    filterButtons: css`
      display: flex;
      align-items: flex-start;
      gap: 0.5rem;
      align-self: stretch;
      position: sticky;
      left: 0;
      bottom: 0;
      width: 100%;
      background: rgba(255, 255, 255, 0.98);
      padding: ${spacing.s};
      z-index: 10;
      border: 1px solid ${colors.border_grey};
      @media (max-width: 767px) {
        width: 100vw;
        background: ${colors.white};
      }
    `,
    columnFooter: css`
      margin-top: ${spacing.s};
    `,
    noResults: css`
      color: ${colors.red};
      text-align: center;
      padding: ${spacing.s} 0;
    `,
    saveBtn: css`
      flex: 1;
      height: 3rem;
      font-size: ${spacing.s};
      background-color: ${colors.buttonRed};
      border: 1px solid ${colors.border_grey};
      border-radius: 0.25rem;
      &:enabled:hover {
        border: 2px solid ${colors.checkNavy};
        background-color: ${colors.surfaceBlue};
        color: ${colors.white};
      }
      &:disabled:hover {
        cursor: unset !important;
      }
      ${breakpoints.s} {
        &:focus-visible {
          color: ${colors.border_black};
          text-decoration: underline;
          text-decoration-color: ${colors.border_black};
          background-color: ${colors.skip_yellow};
          border: 2px solid ${colors.border_black};
        }
      }
    `,
    clearBtn: css`
      flex: 1;
      height: 3rem;
      font-size: ${spacing.s};
      border: 1px solid ${colors.border_grey};
      border-radius: 0.25rem;
      background-color: ${colors.white};
      color: ${colors.navy};
      border-radius: 0.25rem;
      border: 2px solid ${colors.color_aebde6};
      cursor: 'pointer';
      &:disabled {
        background-color: ${colors.white};
        border-color: ${colors.pale_blue};
        color: ${colors.grey_dusty};
        cursor: unset !important;
      }

      &:not(:disabled) {
        &:hover {
          background-color: ${colors.border_grey};
        }
      }
      ${breakpoints.s} {
        &:focus-visible {
          color: ${colors.border_black};
          text-decoration: underline;
          text-decoration-color: ${colors.border_black};
          background-color: ${colors.skip_yellow};
          border: 2px solid ${colors.border_black};
        }
      }
    `,
  };
};
